import { render } from "./SelectDiscountHours.vue?vue&type=template&id=6ef867af&scoped=true"
import script from "./SelectDiscountHours.vue?vue&type=script&lang=js"
export * from "./SelectDiscountHours.vue?vue&type=script&lang=js"

import "./SelectDiscountHours.vue?vue&type=style&index=0&id=6ef867af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef867af"]])

export default __exports__